import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Initialize i18n
import './i18n';

import GlobalLoader from './components/shared/GlobalThreeDotsLoader/GlobalLoader';
import makeStore from './redux/store';
import history from './routing/history';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.scss';
import 'bootstrap/dist/css/bootstrap.css';

const { store } = makeStore();
const root = ReactDOM.createRoot(document.getElementById('root'));

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
}

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <GlobalLoader />
    <HistoryRouter history={history}>
      <App />
    </HistoryRouter>
    <ToastContainer />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
